import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import { formatNumber, shouldHideField } from "../../../utils/numberFormatting";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined } from "../utils";

class HiLoActivatorTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      className,
      fontFamily,
      fontSize,
      textFill,
      labelFill,
      longFill,
      shortFill,
      displayFormat,
      yAccessor,
      options,
      onClick,
      origin: originProp,
      displayValuesFor,
    } = this.props;

    const origin = functor(originProp);
    const {
      chartConfig: { width, height },
    } = moreProps;
    const [x, y] = origin(width, height);

    const currentItem = displayValuesFor(this.props, moreProps);
    let valueText = "n/a";
    let valueFill = longFill;

    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      if (isDefined(item?.P1)) {
        const formattedValue = displayFormat(item.P1);
        if (!shouldHideField(formattedValue)) {
          valueText = `${formattedValue} (Long)`;
          valueFill = longFill;
        }
      }
      if (isDefined(item?.P2)) {
        const formattedValue = displayFormat(item.P2);
        if (!shouldHideField(formattedValue)) {
          valueText = `${formattedValue} (Short)`;
          valueFill = shortFill;
        }
      }
    }

    // Hide entire tooltip if value is n/a
    if (shouldHideField(valueText)) {
      return null;
    }

    const { highPeriod, lowPeriod } = options || {};
    const label = `HiLo (${highPeriod ?? "?"}, ${lowPeriod ?? "?"}): `;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-hi-lo-activator"
      >
        <ToolTipText
          fontFamily={fontFamily}
          fontSize={fontSize}
          fill={textFill}
        >
          <ToolTipTSpanLabel fill={labelFill}>{label}</ToolTipTSpanLabel>
          <tspan fill={valueFill}>{valueText}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

HiLoActivatorTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  longFill: PropTypes.string,
  shortFill: PropTypes.string,
  displayFormat: PropTypes.func,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.shape({
    highPeriod: PropTypes.number,
    lowPeriod: PropTypes.number,
  }),
};

HiLoActivatorTooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip react-stockcharts-hilo-tooltip",
  displayFormat: (value) => formatNumber(value, 2),
  displayValuesFor,
  labelFill: "#6B7280",
  textFill: "#F9FAFB",
  longFill: "#2ecc71",
  shortFill: "#ff4d4d",
};

export default HiLoActivatorTooltip;
